/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AssignTeamMemberBody
 */
export interface AssignTeamMemberBody {
  /**
   *
   * @type {string}
   * @memberof AssignTeamMemberBody
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof AssignTeamMemberBody
   */
  teamMemberId: string;
}

/**
 * Check if a given object implements the AssignTeamMemberBody interface.
 */
export function instanceOfAssignTeamMemberBody(
  value: object,
): value is AssignTeamMemberBody {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  return true;
}

export function AssignTeamMemberBodyFromJSON(json: any): AssignTeamMemberBody {
  return AssignTeamMemberBodyFromJSONTyped(json, false);
}

export function AssignTeamMemberBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AssignTeamMemberBody {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    teamMemberId: json["teamMemberId"],
  };
}

export function AssignTeamMemberBodyToJSON(json: any): AssignTeamMemberBody {
  return AssignTeamMemberBodyToJSONTyped(json, false);
}

export function AssignTeamMemberBodyToJSONTyped(
  value?: AssignTeamMemberBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    teamMemberId: value["teamMemberId"],
  };
}
